import { Skeleton, SxProps } from "@mui/material";

export function RandomTextSkeleton({ sx }: { sx?: SxProps }) {
  const getSkeletonWidth = () =>
    `${Math.floor(Math.random() * (1 + 25 - 5)) + 5}ch`;
  return (
    <Skeleton
      sx={{
        width: getSkeletonWidth(),
        ...sx,
      }}
    />
  );
}
